module.exports = __webpack_public_path__ + "40225305f0980d18b78a6e1dd889b8df.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/12_column_xlarge_x1/public/news/isaac.jpg
// module id = 345
// module chunks = 0